<template>
  <div class="bulletin-read">
    <a-button
      type="primary"
      @click="submitRead"
      :loading="loading"
      :disabled="reads.length > 0"
    >
      <template v-if="reads.length === 0">
        Elolvastam
      </template>

      <template v-else>
        Elolvasva
      </template>
    </a-button>
  </div>
</template>

<script>
import { USER_UPDATE_BULLETIN_UNREAD } from "@/action_types.js";
import axios from "axios";

export default {
  props: {
    id: Number,
  },
  mounted() {
    this.fetchReads();
  },
  data() {
    return {
      loading: false,
      reads: [],
    };
  },
  methods: {
    submitRead() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      return new Promise((resolve) => {
        axios
          .post("/api/v1/companies/1/me/bulletin/news/" + this.id + "/reads")
          .then((response) => {
            if (response.status !== 201) {
              throw new Error("Failed to save read.");
            }

            this.fetchReads();

            this.$store.dispatch(USER_UPDATE_BULLETIN_UNREAD);

            this.loading = false;
          })
          .catch((error) => {
            console.error(error);
            this.loading = true;
            this.$message.error("Az olvasási állapot mentése sikertelen!");
          });
      });
    },
    fetchReads() {
      this.loading = true;
      return new Promise((resolve) => {
        axios
          .get("/api/v1/companies/1/me/bulletin/news/" + this.id + "/reads")
          .then((response) => {
            if (response.status !== 200) {
              throw new Error("Failed to fetch reads.");
            }

            this.reads = response.data;

            resolve(this.article);

            this.loading = false;
          })
          .catch(() => {
            this.loading = true;
            this.$message.error("Az olvasási állapot betöltése sikertelen!");
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bulletin-read {
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
